<template>
  <div class="registrant-and-event">
    <!-- Registrant -->
    <h4 class="mb-0">{{registration.registrant.full_name}}</h4>
    <h5 class="text-center text-lg-left">
      <div
        v-if="isValidPricing"
        class="badge badge-pill badge-secondary mr-2">
        {{registration.pricing_package.label}}
      </div>
      <div
        v-else
        class="badge badge-pill badge-danger mr-2">
        {{registration.pricing_package.label}} No Longer Available - Please Remove
      </div>

      <div
        v-if="isWaitlist"
        class="badge badge-pill badge-warning">
        Waitlist
      </div>

      <div
        v-else-if="isFailed"
        class="badge badge-pill badge-danger">
        Roster Full - Please Remove
      </div>

      <div
        v-else
        class="badge badge-pill badge-success">
        Active Roster
      </div>
    </h5>
    <!-- / Registrant -->

    <!-- Event -->
    <div class="mt-3">
      <h4 class="mb-0">{{registration.event.name}}</h4>
      <div class="mt-1">
        <span class="text-highlight">Starts:</span>
        {{registration.event.display_start_date_time}}
      </div>
      <div>
        <span class="text-highlight">Ends:</span>
        {{registration.event.display_end_date_time}}
      </div>
    </div>
    <!-- / Event -->
  </div>
</template>

<script>
import AppMixin from '../services/mixin.app';

export default {
  name: 'registrant-and-event',
  props: ['registration'],
  mixins: [AppMixin],
  computed: {
    isWaitlist() {
      return this.registration.waitlist
        || this.registration.state === 'waitlist';
    },
    isFailed() {
      return this.registration.state === 'failed';
    },
    isValidPricing() {
      return this.registration.registered || this.registration.pricing_package.is_open;
    },
  },
};
</script>
